import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { filter } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class SideBarService {

  sideBarOpened: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  basketOpened: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.sideBarOpened = new BehaviorSubject<boolean>(false);
    this.basketOpened = new BehaviorSubject<boolean>(false);
    this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(event => {
      this.close();
      this.closeBasket();
    });
  }

  toggle() {
    this.sideBarOpened.next(!this.sideBarOpened.getValue());
  }

   toggleBasket(){
    this.basketOpened.next(!this.basketOpened.getValue());
   }

   openBasket(){
    this.basketOpened.next(true);
   }

   open(){
    this.sideBarOpened.next(true);
  }

  close() {
    this.sideBarOpened.next(false);
  }

  closeBasket() {
    this.basketOpened.next(false);
  }

  closeSideNav(){
    //this.sideBarService.sideBarOpened.subscribe(sideBarOpened => this.slidebarOpened = sideBarOpened);
    //if (this.slidebarOpened === true) {
    this.router.navigate([{
      outlets:{
        sidebar: null
      }
    }], {
      relativeTo: this.route
    }).then(res => {
      //this.sidenav.close();
    }, error => {

    })
    //}
  }
}
